<template>
    <nav class="navbar">
        <div class="navbar-left">
            <img :src="state.styles.logo" alt="Logo" class="logo" />
        </div>
        <div class="navbar-right">
            <ibu-select-language-popup isDarkMode="true" />
        </div>
    </nav>
</template>

<script>
import ibuSelectLanguagePopup from '@/components/ibuSelectLanguagePopup/ibuSelectLanguagePopup.vue';
// import ic_logo_kex from './imgs/ic_logo_kex.png'
import { defineEmits, defineProps, ref, reactive } from 'vue';
import { useAppStore } from '@/stores/index';
export default {
    components: {
        ibuSelectLanguagePopup
    },
    data() {
        return {
        }
    },
    setup() {
        const appStore = useAppStore()
        const state = reactive({
            styles: {
                defaultColor: appStore.config.defaultThemeColor,
                logo: appStore.config.logo,
            }
        })
        return {
            state
        }
    }

};
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
@media screen and (min-width: $screen_min_width) {
    .navbar {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 135px 0 135px;
        height: 90px;
        background-color: v-bind('state.styles.defaultColor');
        z-index: 10000;
    }

    .logo {
        height: 42px;
    }
}

@media screen and (max-width: $screen_min_width) {
    .navbar {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 32px 0 32px;
        height: 122px;
        background-color: v-bind('state.styles.defaultColor');
        z-index: 10000;


    }

    .logo {
        height: 58px;
    }
}
</style>
